import { createApp } from "vue";
import ChatWidget from "./components/ChatWidget.vue";
import "../scss/chatbot.scss";
import type { ChatbotConfig } from "./types";

declare global {
  interface Window {
    PrestechWebsiteChatbot?: ChatbotConfig;
  }
}

const mount = (): void => {
  const root = document.querySelector("[data-prestech-chatbot-root]");
  if (!root) {
    return;
  }

  const config = window.PrestechWebsiteChatbot ?? {
    restUrl: "",
    nonce: "",
    sessionStorageKey: "prestech.websiteChatbot.session.v1",
    compatibility: {
      socialChatSelectors: [".qlwapp__container", ".qlwapp", "#qlwapp"],
      backToTopSelector: "#back-to-top",
      themeProfile: "engitech"
    }
  };

  createApp(ChatWidget, { config }).mount(root);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount);
} else {
  mount();
}
